import { useSearchParams } from "react-router-dom";
import { PartyPopper } from "lucide-react";
import { RequireAuth } from "@/components/site/Shared";
import { KycPanel } from "@/components/kyc/KycPanel";

export default function Verify() {
  const [params] = useSearchParams();
  return (
    <RequireAuth>
      <div className="container-x max-w-3xl py-12" data-testid="verify-page">
        {params.get("welcome") && (
          <div className="mb-8 flex items-start gap-3 rounded-2xl bg-hc-green p-5 text-white" data-testid="verify-welcome">
            <PartyPopper className="h-6 w-6 shrink-0 text-hc-gold" />
            <div><p className="font-display text-lg font-bold">Welcome to HooreCars! Your account is ready.</p>
              <p className="mt-1 text-sm text-white/80">One last step: upload your driving licence, Aadhaar and a live selfie. Our team checks them manually before your first trip.</p></div>
          </div>
        )}
        <p className="label-eyebrow">Your documents</p>
        <h1 className="mt-2 mb-8 text-3xl font-bold tracking-tight sm:text-4xl">Verification</h1>
        <KycPanel />
      </div>
    </RequireAuth>
  );
}
